import { render, staticRenderFns } from "./RestartAccount.vue?vue&type=template&id=aed25790&scoped=true&"
import script from "./RestartAccount.vue?vue&type=script&lang=js&"
export * from "./RestartAccount.vue?vue&type=script&lang=js&"
import style0 from "./RestartAccount.vue?vue&type=style&index=0&id=aed25790&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed25790",
  null
  
)

export default component.exports